// extracted by mini-css-extract-plugin
export default {"productInfo":"index_productInfo__gFfFN","infoImg":"index_infoImg__DFM3u","info":"index_info__aNKoj","text":"index_text__B5N7y"};